export const floatLabel = (
  isCompact: boolean,
  isFocussed: boolean,
  isEmpty: boolean
) => isCompact && (isFocussed || !isEmpty);
